import { Component, OnInit,Input, NgModule,Inject} from '@angular/core';
import { Proceso, Procedimiento } from 'src/app/interfaces/interfaces';
import { FormGroup, FormControl, Validators,FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogTitle} from '@angular/material/dialog';



@Component({
  selector: 'app-modal-procedimiento',
  templateUrl: './modal-procedimiento.component.html',
  styleUrls: ['./modal-procedimiento.component.css']
})
export class ModalProcedimientoComponent implements OnInit {

  //Sección de variables
  proceso:Proceso;
  rol: string;
  formProcedimiento: FormGroup;

  
  constructor(public dialog:MatDialog,@Inject(MAT_DIALOG_DATA) public datos:any) 
  {}

  ngOnInit(): void {
    this.formProcedimiento= new FormGroup({
      rol_procesoDetalle: new FormControl(''),
      puesto_procesoDetalle: new FormControl(''),
      tiempoOperacion_procesoDetalle: new FormControl(''),
      tiempoEspera_procesoDetalle: new FormControl(''),
      nivelTabular_procesoDetalle: new FormControl(''),
      numParticipantes_procesoDetalle: new FormControl(''),
      tipoProceso_procesoDetalle: new FormControl(''),
      id_proceso : new FormControl(''),
      id_procesoDetalle: new FormControl('')
    })

    if(this.datos['data'])
    {
      let json=JSON.parse(this.datos['data']);
        this.formProcedimiento.patchValue({
          rol_procesoDetalle:json['rol_procesoDetalle'],
          puesto_procesoDetalle:json['puesto_procesoDetalle'],
          tiempoOperacion_procesoDetalle:json['tiempoOperacion_procesoDetalle'],
          tiempoEspera_procesoDetalle:json['tiempoEspera_procesoDetalle'],
          nivelTabular_procesoDetalle:json['nivelTabular_procesoDetalle'],
          numParticipantes_procesoDetalle:json['numParticipantes_procesoDetalle'],
          tipoProceso_procesoDetalle:json['tipoProceso_procesoDetalle'],
          id_proceso:json['id_proceso'],
          id_procesoDetalle:json['id_procesoDetalle']
        })

    }
  }

}
